// frontend/src/utils/toast.ts
import { toast as toastify, ToastOptions } from 'react-toastify';

// Benutzerdefinierte Standardoptionen
const defaultOptions: ToastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true
};

// Toast-Utility-Funktionen
export const toast = {
  success: (message: string, options?: ToastOptions) => {
    return toastify.success(message, { ...defaultOptions, ...options });
  },
  
  error: (message: string, options?: ToastOptions) => {
    return toastify.error(message, { 
      ...defaultOptions, 
      autoClose: 5000, // Längere Anzeigedauer für Fehler
      ...options 
    });
  },
  
  info: (message: string, options?: ToastOptions) => {
    return toastify.info(message, { ...defaultOptions, ...options });
  },
  
  warning: (message: string, options?: ToastOptions) => {
    return toastify.warn(message, { 
      ...defaultOptions, 
      autoClose: 4000, // Mittlere Anzeigedauer für Warnungen
      ...options 
    });
  }
};

// Hinweis: Die successWithAction Methode wurde entfernt, da sie 
// TypeScript-Fehler verursacht. Ein entsprechender Toast mit Aktion
// sollte direkt in den Komponenten mit JSX implementiert werden.